import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { ColorSystemNegative1, FontLineHeightNormal, Spacing4 } from 'autogen/design-tokens/tokens';
import { MinimumSalesQuantityBuyButton } from 'autogen/translation-keys/trans-website-product';
import { Notice } from 'autogen/translation-keys/trans-website-shared';
import { Typography } from 'components/generic/typography';
import { format } from 'modules/helpers/strings';

const BundleNoticeText = styled(Typography.Body)`
    margin-bottom: ${Spacing4};
    line-height: ${FontLineHeightNormal};
`;

const ColoredText = styled.span`
    color: ${ColorSystemNegative1};
`;

export default function BundleNotice({
    minimumSalesQuantity,
    ...restProps
}: {
    minimumSalesQuantity: number;
}): JSX.Element {
    const { t } = useTranslation();

    return (
        <BundleNoticeText size="M" strong {...restProps}>
            <ColoredText>{t(Notice)}</ColoredText>{' '}
            {format(t(MinimumSalesQuantityBuyButton))(minimumSalesQuantity.toString())}
        </BundleNoticeText>
    );
}
